export function generateGid(value: string): string {
  return value.length > 3 ? value.substring(0, 3) : value;
}
